export const categoriNumber = (cateId) => {
  // 카테고리 넘버
  if (cateId === "1") {
    return "디지털기기";
  }
  if (cateId === "2") {
    return "공구";
  }
  if (cateId === "3") {
    return "생활가전";
  }
  if (cateId === "4") {
    return "잡화";
  }
  if (cateId === "5") {
    return "스포츠/레저";
  }
  if (cateId === "6") {
    return "취미/게임/음반";
  }
  if (cateId === "7") {
    return "도서";
  }
  if (cateId === "8") {
    return "기타";
  }
};
